import { IncidenceTypesRepositoryT } from "../../domain/ports/incidenceTypes.repository";

type GetIncidenceTypesParamsT = {
  incidenceTypesRepository: IncidenceTypesRepositoryT;
};

export const getIncidenceTypes = async ({
  incidenceTypesRepository,
}: GetIncidenceTypesParamsT) => await incidenceTypesRepository.getAll();
